
import React, { useState } from "react";
import styled from "styled-components";
import { scroller } from 'react-scroll';

import colors from "../styles/colors";

export default ({ links = [] }) => {
  const [open, setOpen] = useState(false);

  const scrollTo = (e, name) => {
    console.log(
      'scrollTo',
      name
    )
    e.preventDefault();
    setOpen(false);
    // Somewhere else, even another file
    scroller.scrollTo(name, {
      duration: 300,
      delay: 0,
      smooth: true,
      withHash: true,
      // containerId: 'ContainerElementID',
      //offset: 0, // Scrolls to element + 50 pixels down the page
    })
  }

  return (
    <Menu>
      <Toggler onClick={() => { setOpen(!open) }}>
        {open
          ? <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
        }
      </Toggler>
      <Overlay open={open}>
        <Background onClick={() => setOpen(!open)} />
        {links.map(link => (<Link key={link.section} onClick={(e) => scrollTo(e, link.section)} href="#">{link.title}</Link>))}
      </Overlay>
    </Menu>
  )
};


const Toggler = styled.button`
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 11;
  background: ${colors.white};
  padding: 1rem;
  border: none;
  border-radius: 1rem;
  display: block;
  line-height: 0;
  cursor: pointer;
  border: 1px solid transparent;
  box-shadow:  20px 20px 60px #d9d9d9,
             -20px -20px 60px #ffffff;

  &:active,
  &:hover {
    border: 0;
    outline: 0;
    background: 1px solid ${colors.textHover};
  }

  &:focus {
    border: 0;
    outline: 0;
  }
`

const Menu = styled.nav`
`;

const Background = styled.div`
  position: absolute;
  background: ${colors.offWhite09};
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
`
const Overlay = styled.div`
  overflow: hidden;
  top: ${props => props.open ? "0" : "100%"};
  transition: all .2s ease;
  display: flex;
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Link = styled.a`
  z-index: 2;
  margin: 1rem 0;
  text-decoration: none;
  font-weight: 800;
  font-size: 3rem;

  &:hover,
  &:active {
    text-decoration: underline;
    color: ${colors.text};
  }
`